import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { SpinnerLoading } from "../../components/Loadings";
import SignUp from "./components/SignUp";
import SignIn from "./components/SignIn";
import { LOGO } from "../../Utility/static";
import { getPublicTenantbyId } from "../../Utility/ApiService";

export default function SignUpSignIn() {
  const { state } = useLocation();
  const [isSignInSelected, setIsSignInSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalSuccess, setModalSuccess] = useState();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams({ tenantId: "" });
  const tenantId = searchParams.get("tenantId");

  const [showEmailError, setShowEmailError] = useState(false);

  const [tenant, setTenant] = useState();
  const [hideAuth, setHideAuth] = useState(false);

  const redirectToLogin = () => setIsSignInSelected(true);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const memberStatementId = urlSearchParams.get("memberStatementId");
    if (state?.isSignIn || memberStatementId) {
      setIsSignInSelected(true);
    } else {
      setIsSignInSelected(false);
    }
  }, []);

  useEffect(() => {
    if (tenantId) {
      getTenantbyId(tenantId);
    }
  }, [tenantId]);

  const getTenantbyId = async (id) => {
    await getPublicTenantbyId(id)
      .then((data) => {
        setTenant(data);
      })
      .catch((err) => {
        console.log("fetchAllMaintenances ", err);
        toast.error("Error while get tenant");
      });
  };

  return (
    <div className="forms" style={{ position: "relative" }}>
      <div id="layout-wrapper">
        {loading && (
          <div className="loadingSpinner">
            <SpinnerLoading />
          </div>
        )}

        <div className="form-pages">
          <section className="sidebar align-items-center">
            <img src={LOGO} alt="ds" className="logo-img" />
          </section>

          <div className="errors">
            {showEmailError && (
              <div className="error warning">
                A user with this email is already registered. Perhaps you have Forgot Password or try Sign In. Another
                way using other email.
                <a
                  href="#"
                  className="close-error"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowEmailError(false);
                  }}
                >
                  <img src={require("../../assets/images/close.svg").default} alt="" />
                </a>
              </div>
            )}

            {modalSuccess && (
              <div className="errors">
                <div className="error success">
                  {modalSuccess}
                  <a
                    href=""
                    className="close-error"
                    onClick={(e) => {
                      e.preventDefault();
                      setModalSuccess();
                    }}
                  >
                    <img src={require("../../assets/images/close.svg").default} alt="" />
                  </a>
                </div>
              </div>
            )}
          </div>

          <section className="content align-items-center justify-content-center">
            <div className="auth-form bg-white">
              {!hideAuth && (
                <>
                  <div className="d-flex justify-content-between ">
                    <h2>Welcome!</h2>
                    <i
                      className="fa fa-home cursor-pointer mt-3"
                      onClick={() => navigate("/")}
                      style={{ fontSize: "25px" }}
                    />
                  </div>

                  <ul className="nav nav-pills tab-v1">
                    <li className="nav-item">
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          setIsSignInSelected(!isSignInSelected);
                        }}
                        className={"nav-link " + (!isSignInSelected ? "active" : "")}
                      >
                        Sign Up
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          setIsSignInSelected(!isSignInSelected);
                        }}
                        className={"nav-link " + (isSignInSelected ? "active" : "")}
                      >
                        Sign In
                      </a>
                    </li>
                  </ul>
                </>
              )}

              <div className="auth-form-content">
                <div className="with-email">
                  {isSignInSelected ? (
                    <SignIn
                      tenant={tenant}
                      setLoading={setLoading}
                      setModalSuccess={setModalSuccess}
                      setHideAuth={setHideAuth}
                    />
                  ) : (
                    <SignUp
                      tenant={tenant}
                      redirectToLogin={redirectToLogin}
                      setLoading={setLoading}
                      setHideAuth={setHideAuth}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
